import { TbIcon } from '@framework/ui/components/icon/TbIcon.tsx';
import { InfoPopover } from '@framework/ui/components/popover/InfoPopover.tsx';
import {
  InfoPopoverContentWrapper,
  InfoPopoverText,
} from '@framework/ui/components/popover/InfoPopoverContent.tsx';
import { IconHelpFilled } from '@tabler/icons-react';
import styled from 'styled-components';

/**
 * Contenuto del trigger di InfoPopover: testo in resa link accanto
 * all'icona, per non alterare la resa del footer dell'editor.
 */
const UsageInfoLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: ${({ theme }) => theme.colorLink};

  &:hover {
    text-decoration: underline;
  }
`;

/**
 * Nota d'uso dell'editor rich text avanzato: il testo stesso apre al click
 * il popover con le istruzioni operative dello strumento. Mostrata nel
 * footer accanto ad "Aggiungi Testo", vale per ogni campo che usa l'editor.
 */
export function RichTextUsageInfoPopover() {
  return (
    <InfoPopover
      title="Testi multipli e condizioni"
      iconAriaLabel="Utilizzo campo di testo avanzato"
      icon={
        <UsageInfoLabel>
          Utilizzo campo di testo avanzato
          <TbIcon icon={IconHelpFilled} />
        </UsageInfoLabel>
      }
      content={
        <InfoPopoverContentWrapper>
          <InfoPopoverText>
            Con <b>Aggiungi Testo</b> si creano stringhe di testo indipendenti,
            mostrate una di seguito all&apos;altra.
          </InfoPopoverText>
          <InfoPopoverText>
            Con <b>Regole</b> ogni stringa può essere mostrata o nascosta in
            base ai valori di altri campi della sezione.
          </InfoPopoverText>
          <InfoPopoverText>
            Con l&apos;icona ⓘ della barra strumenti un blocco diventa
            un&apos;icona informativa: il testo compare in un popup al click,
            invece che in linea.
          </InfoPopoverText>
          <InfoPopoverText>
            Con <b>Variabile</b> si inseriscono nel testo valori dinamici presi
            da altri campi della sezione.
          </InfoPopoverText>
        </InfoPopoverContentWrapper>
      }
    />
  );
}
